
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";


// import * as api from "../constant/API";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const Skill = () => {

    const [searchInput, setSearchInput] = useState("");
    const [sportId, setSportId] = useState("");
    const [programId, setProgramId] = useState("");
    const [sportList, setSportList] = useState([]);
    const [progList, setProgList] = useState([]);
    const [sklList, setSklList] = useState([]);
    const [skillId, setSkillId] = useState("");
    const [skillName, setSkillName] = useState("");
    const [skillDesc, setSkillDesc] = useState("");
    const [skilOrder, setSkilOrder] = useState("");
    const [modalSportId, setModalSportId] = useState("");
    const [modalProgramId, setModalProgramId] = useState("");
    const [skilStatus, setSkilStatus] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        getSportList();
        getProgramList();
    }, [])

    function getSportList() {
        const getSprtList = api.SportList;
        fetch(getSprtList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.code == 401) {
                    Utils.logoutUser();
                }
                if (sprtResult.data != null) {
                    setSportList(sprtResult.data)
                }

            })
            .catch((error) => {
                console.log('Failed to fetch sport list', error);
            })
    }

    function getProgramList() {
        const progList = api.ProgramsList;
        fetch(progList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((progResponse) => progResponse.json())
            .then((progResult) => {
                if (progResult.code == 401) {
                    Utils.logoutUser();
                }
                if (progResult.data != null) {
                    setProgList(progResult.data)
                }

            })
            .catch((error) => {
                console.log('Failed to fetch program list', error)
            })
    }

    function getSkillList(progId) {
        const getList = api.SportSkillList + '/' + sportId + '/' + progId // + "?sportId=" + sportId + "&pgmId=" + progId;
        fetch(getList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sklResponse) => sklResponse.json())
            .then((sklResult) => {
                if (sklResult.code == 401) {
                    Utils.logoutUser();
                }
                if (sklResult.data != null) {
                    setSklList(sklResult.data)
                }
                setShowTable(true)
            })
            .catch((error) => {
                console.log('Failed to fetch skill list', error)
            })
    }

    function editSkill(row) {
        const id = row.skillId;
        const getDetails = api.GetSkillDetails + '/' + id //+ "?skillId=" + id;
        fetch(getDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((detResponse) => detResponse.json())
            .then((detResult) => {
                if (detResult.code == 401) {
                    Utils.logoutUser();
                }
                if (detResult.error == false) {
                    setSkillId(detResult.data.skillId)
                    setSkillName(detResult.data.skillName)
                    setSkillDesc(detResult.data.skillDescription)
                    setModalSportId(detResult.data.skillSportId)
                    setModalProgramId(detResult.data.skillProgramId)
                    setSkilOrder(detResult.data.skillOrder)
                    setSkilStatus(detResult.data.skillStatus)
                    setIsEdit(true)
                    setOpenModal(true)
                }
                else {
                    Swal.fire(detResult.message)
                }
            })
    }

    function setInitial() {
        setSkillId('')
        setSkillName('')
        setSkillDesc('')
        setModalSportId('')
        setModalProgramId('')
        setSkilOrder('')
        setSkilStatus('')
    }

    function saveSkill(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateSkill()
            } else {
                const formData = new FormData();
                formData.append('skillName', skillName)
                formData.append('skillDescription', skillDesc)
                formData.append('skillSportId', modalSportId)
                formData.append('skillProgramId', modalProgramId)
                formData.append('skillOrder', skilOrder)
                formData.append('skillStatus', skilStatus)

                const createSkill = api.skillCreate;
                fetch(createSkill, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
            setOpenModal(false);
        }
    }

    function updateSkill() {
        const formData = new FormData();
        formData.append('skillName', skillName)
        formData.append('skillDescription', skillDesc)
        formData.append('skillSportId', modalSportId)
        formData.append('skillProgramId', modalProgramId)
        formData.append('skillOrder', skilOrder)
        formData.append('skillStatus', skilStatus)
        formData.append('skillId', skillId)

        const updateSkill = api.skillUpdate;
        fetch(updateSkill, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    const filteredData = sklList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.skillName}</span>;
    };

    const descriptionRender = (rowData) => {
        return <span>{rowData.skillDescription}</span>;
    };

    const sportRender = (rowData) => {
        return <span>{rowData.sportName}</span>;
    };

    const programRender = (rowData) => {
        return <span>{rowData.programName}</span>;
    };

    const orderRender = (rowData) => {
        return <span>{rowData.skillOrder}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSkill(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-lg-12">
                                                            <div className="row col-lg-8 court-sortby sortbyset">
                                                                <div className="col-lg-6 mb-10">
                                                                    <label className="sortbytitle"><h6>Sport</h6></label>
                                                                    <Select
                                                                        value={sportList.find(sprt => sprt.sportId === sportId) ? {
                                                                            value: sportId,
                                                                            label: sportList.find(sprt => sprt.sportId === sportId).sportName
                                                                        } : null}
                                                                        onChange={(e) => {
                                                                            setSportId(e.value);
                                                                        }}
                                                                        options={sportList.map(sprt => ({
                                                                            value: sprt.sportId,
                                                                            label: sprt.sportName
                                                                        }))}>
                                                                    </Select>
                                                                </div>
                                                                <div className="col-lg-6 mb-10">
                                                                    <label className="sortbytitle"><h6>Program</h6></label>
                                                                    <Select
                                                                        value={progList.find(prg => prg.programId === programId) ? {
                                                                            value: programId,
                                                                            label: progList.find(prg => prg.programId === programId).programName
                                                                        } : null}
                                                                        onChange={(e) => {
                                                                            setProgramId(e.value)
                                                                            getSkillList(e.value)
                                                                        }}
                                                                        options={progList.map(prg => ({
                                                                            value: prg.programId,
                                                                            label: prg.programName
                                                                        }))}>
                                                                    </Select>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                {roleId == '1' ? (
                                                                    <>
                                                                        <div className="row col-lg-12">
                                                                            <div className="save-changes">
                                                                                <Button
                                                                                    className="btn-secondary text-uppercase"
                                                                                    variant="success"
                                                                                    onClick={() => { setOpenModal(true); setIsEdit(false); setInitial(); }}
                                                                                >
                                                                                    <i className="fas fa-plus">Add Skill</i>
                                                                                </Button>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        {showTable && (
                                                            <>
                                                                <div className="col-lg-12">
                                                                </div>
                                                                <div className="col-lg-12">
                                                                </div>
                                                                <div className="col-lg-6">
                                                                </div>
                                                                <div className="col-lg-6">
                                                                    <div className="dataTables_filter">
                                                                        <label>
                                                                            <input
                                                                                type="text"
                                                                                value={searchInput}
                                                                                onChange={(e) => setSearchInput(e.target.value)}
                                                                                placeholder="Search"
                                                                                className="form-control"
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                {showTable && (
                                                    <div className="tab-content">
                                                        <div className="col-lg-12">
                                                        </div>
                                                        <div className="col-lg-12">
                                                        </div>
                                                        <div className="col-lg-6">
                                                        </div>
                                                        {showTable && (
                                                            <div className="tab-content">
                                                                <div
                                                                    className="tab-pane fade show active"
                                                                    id="nav-Recent"
                                                                    role="tabpanel"
                                                                    aria-labelledby="nav-Recent-tab"
                                                                    tabIndex={0}
                                                                >
                                                                    <div className="table-responsive table-datatble">
                                                                        <DataTable
                                                                            className="table datatable"
                                                                            value={filteredData}
                                                                            paginator
                                                                            rows={10}
                                                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                            pageLinkSize={3}
                                                                        >
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="slNo"
                                                                                body={slNoRender}
                                                                                header="Sl No"
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="skillName"
                                                                                header="Name"
                                                                                body={nameRender}
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="skillDescription"
                                                                                header="Description"
                                                                                body={descriptionRender}
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="sportName"
                                                                                header="Sport"
                                                                                body={sportRender}
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="programName"
                                                                                header="Program"
                                                                                body={programRender}
                                                                            ></Column>
                                                                            <Column
                                                                                sortable
                                                                                headerClassName="text-uppercase"
                                                                                field="skillOrder"
                                                                                header="Order"
                                                                                body={orderRender}
                                                                            ></Column>
                                                                            {(roleId == '1') ? (
                                                                                <Column
                                                                                    className="text-link"
                                                                                    body={editDetails}
                                                                                ></Column>
                                                                            ) : null}
                                                                        </DataTable>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                onHide={() => setOpenModal(false)}
                size="md">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 text-uppercase">{isEdit ? "Edit " : "Add "}Skill</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="mb-10">
                            <label className="form-label">Skill</label>
                            <input
                                id="skillName"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                value={skillName}
                                placeholder="Skill Name"
                                required
                                onChange={(e) => {
                                    setSkillName(e.target.value)
                                }}
                            />
                        </div>
                        <div className="mb-10">
                            <label className="form-label">Description {isEdit ? 'Edit' : ''}</label>
                            <input
                                id="skillDesc"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                value={skillDesc}
                                placeholder="Skill Description"
                                required
                                onChange={(e) => {
                                    setSkillDesc(e.target.value)
                                }}
                            />
                        </div>
                        <div className="col-lg-12 mb-10">
                            <label className="form-label">Sport</label>
                            <Select
                                value={sportList.find(sprt => sprt.sportId === modalSportId) ? {
                                    value: modalSportId,
                                    label: sportList.find(sprt => sprt.sportId === modalSportId).sportName
                                } : null}
                                onChange={(e) => {
                                    setModalSportId(e?.value)
                                }}
                                required
                                placeholder="Select a Sport"
                                options={sportList.map(sprt => ({
                                    value: sprt.sportId,
                                    label: sprt.sportName
                                }))}>
                            </Select>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <label className="sortbytitle"><h6>Program</h6></label>
                            <Select
                                value={progList.find(prg => prg.programId === modalProgramId) ? {
                                    value: modalProgramId,
                                    label: progList.find(prg => prg.programId === modalProgramId).programName
                                } : null}
                                onChange={(e) => {
                                    setModalProgramId(e.value)
                                }}
                                required
                                options={progList.map(prg => ({
                                    value: prg.programId,
                                    label: prg.programName
                                }))}>
                            </Select>
                        </div>
                        <div className="mb-10">
                            <label className="form-label">Order</label>
                            <input
                                id="skillOrder"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                value={skilOrder}
                                placeholder="Skill Order"
                                required
                                onChange={(e) => {
                                    setSkilOrder(e.target.value)
                                }}
                            />
                        </div>
                        {isEdit ?
                            <>
                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                    <label className="form-label">Status</label>
                                </div>
                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                    <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                        <input
                                            className="form-check-input text-end"
                                            type="checkbox"
                                            checked={skilStatus === '1'}
                                            id="instistatus"
                                            onChange={(e) => {
                                                setSkilStatus(e.target.checked ? '1' : '0')
                                            }}
                                        />
                                    </div>
                                </div>
                            </> : null
                        }
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        onClick={saveSkill}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />{isEdit ? " Update" : " Save"}</b>
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Skill;